module.exports = "/packs/icon-time-39e637b84ae63a42a6e49680fcb1edfc.png";